export const COUPON_TEMPLATE_COLORS = [
  ['#093A32', '#FFA103'],
  ['#F18430', '#FFFFFF'],
  ['#42A5F5', '#1E88E5'],
  ['#EF5350', '#C62828'],
  ['#FF9800', '#EF6C00'],
];
